import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * FileNote icon
 *
 * @category Files/Forms/Editing
 */
const FileNote = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M26.135 10.706c-1.322-1.78-4.213-4.35-6.005-6.215-.667-.63-1.248-1.236-2.187-1.335-2.966 0-8.49-.642-10.652.68-1.334.84-1.865 2.372-1.791 3.892v13.963c.098 2.953-.371 4.164.988 5.82 1.829 1.977 3.423 1.36 7.142 1.483 2.867-.025 5.857.05 8.662-.037 2.743.05 4.449-2.435 4.19-5.03.012-2.99 0-7.08 0-9.872-.013-1.792.06-2.608-.297-3.25l-.062-.099zm-6.957-5.338c.235-.025.668.395 1.236.976 1.409 1.458 3.608 3.448 3.707 4.004 0 .098-.05.16-.148.21-.803.26-1.644.11-2.447.074-1.952-.173-2.496-.902-2.607-2.99 0-.742-.185-1.582.185-2.237l.087-.025zm5.672 20.858c-.519 1.087-1.668 1.557-3.67 1.532h-9.897c-2.756.235-4.77-.852-4.56-3.633.074-4.102-.16-13.048.099-17.46.284-1.952 2.372-2.36 4.077-2.36 2.04.124 4.387-.383 6.08.408.741.519.766 1.409.877 2.274.1 2.001.915 4.003 3.077 4.423 1.668.47 4.448-.148 4.275 2.336-.16 3.472.445 9.07-.308 12.332l-.062.136z"
        />
        <path
          fill="currentColor"
          d="M21.87 19.1c.796 0 .796 1.235 0 1.235H10.13c-.796 0-.796-1.236 0-1.236zm0 3.708c.796 0 .796 1.236 0 1.236H10.13c-.796 0-.796-1.236 0-1.236z"
        />
      </svg>
    );
  }
);

FileNote.displayName = 'FileNote';

export { FileNote };
